// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1DatabasePhase = {
  DatabasePhaseNone: '',
  DatabasePhaseCreating: 'Creating',
  DatabasePhaseRunning: 'Running',
  DatabasePhasePaused: 'Paused',
} as const;
export type V1DatabasePhase =
  (typeof V1DatabasePhase)[keyof typeof V1DatabasePhase];

export function instanceOfV1DatabasePhase(value: any): boolean {
  for (const key in V1DatabasePhase) {
    if (Object.prototype.hasOwnProperty.call(V1DatabasePhase, key)) {
      if (V1DatabasePhase[key as keyof typeof V1DatabasePhase] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V1DatabasePhaseFromJSON(json: any): V1DatabasePhase {
  return V1DatabasePhaseFromJSONTyped(json, false);
}

export function V1DatabasePhaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1DatabasePhase {
  return json as V1DatabasePhase;
}

export function V1DatabasePhaseToJSON(value?: V1DatabasePhase | null): any {
  return value as any;
}

export function V1DatabasePhaseToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1DatabasePhase {
  return value as V1DatabasePhase;
}
